import { render, staticRenderFns } from "./YA_Loading.vue?vue&type=template&id=1e235e0f&scoped=true"
import script from "./YA_Loading.vue?vue&type=script&lang=js"
export * from "./YA_Loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e235e0f",
  null
  
)

export default component.exports